import { initSubRoutes } from '../../../utils/router';

const RoutesAccessibilite = initSubRoutes({
    route: '/accessibilite',
    subroutes: {},
    nom: 'Accessibilité',
});

export default RoutesAccessibilite;
